module.exports = __webpack_public_path__ + "img/content3.356007b4.png";